import React from 'react';
import { Link } from "react-router-dom";
import { Shield01 } from "@untitledui/icons/Shield01";
import { BookClosed } from "@untitledui/icons/BookClosed";

const TextPageNavigation = ({activePage}) => {
    return (
        <div className='text-page-navigation'>
            <ul>
                <li className={`${activePage === 'privacy' ? 'active' : ''}`}>
                    <Link to="/privacy-policy">
                        <Shield01 
                            color={"#7F56D9"}
                            size={24}
                        />
                        Privacy Policy
                    </Link>
                </li>
                <li className={`${activePage === 'terms' ? 'active' : ''}`}>
                    <Link to={'/terms'}>
                        <BookClosed 
                            color={"#7F56D9"}
                            size={24}
                        />
                        Terms & Conditions
                    </Link>
                </li>
            </ul>
        </div>  
    );
}

export default TextPageNavigation;